var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeKuchSides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_26712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.458543 65.4936L24.2394 154.238L65.4257 0.526452L0.458543 65.4936Z",
    fill: "url(#paint0_linear_903_26712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4297 0.526367L177.955 113.052L154.176 24.3061L65.4297 0.526367Z",
    fill: "url(#paint1_linear_903_26712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2422 154.238L112.987 178.019L177.954 113.052L24.2422 154.238Z",
    fill: "url(#paint2_linear_903_26712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4257 0.526452L24.2394 154.238L177.951 113.052L65.4257 0.526452Z",
    fill: "url(#paint3_linear_903_26712)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_903_26712",
    x1: 31.9868,
    y1: 162.124,
    x2: 33.2544,
    y2: -8.9955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_903_26712",
    x1: 99.9597,
    y1: 77.1355,
    x2: 159.535,
    y2: 21.3632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26EBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999463,
    stopColor: "#6AFFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AFFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_903_26712",
    x1: 41.8947,
    y1: 163.177,
    x2: 157.242,
    y2: 143.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_903_26712",
    x1: 95.9947,
    y1: 159.794,
    x2: 136.134,
    y2: -45.9717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26EBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_26712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeKuchSides);
export default __webpack_public_path__ + "static/media/Type=Kuch_Sides.2f2de55ca76c577a45953b818f2a46b0.svg";
export { ForwardRef as ReactComponent };